import './App.css';
import KonsaltingContainer from './KonsaltingContainer/KonstaltingContainer'

function App() {
  return (
    <div className="App">
      <KonsaltingContainer />
    </div>
  );
}

export default App;
